import { supabase } from "@/integrations/supabase/client";
import imageCompression from "browser-image-compression";

export const useFileUpload = () => {
  const compressImage = async (file: File) => {
    console.log('Original image size:', (file.size / 1024 / 1024).toFixed(2), 'MB');
    
    const options = {
      maxSizeMB: 1,
      maxWidthOrHeight: 1920,
      useWebWorker: true,
      fileType: file.type,
      initialQuality: 0.7,
    };

    try {
      const compressedFile = await imageCompression(file, options);
      console.log('Compressed image size:', (compressedFile.size / 1024 / 1024).toFixed(2), 'MB');
      
      if (compressedFile.size >= file.size) {
        console.log('Compression did not reduce file size, using original');
        return file;
      }
      
      return compressedFile;
    } catch (error) {
      console.error("Image compression failed:", error);
      return file;
    }
  };

  const processFile = async (file: File) => {
    if (file.type.startsWith('image/')) {
      console.log('Processing image:', file.name, 'Type:', file.type);
      const processedFile = await compressImage(file);
      console.log('Processing complete for:', file.name);
      return processedFile;
    }
    
    console.log('Skipping compression for non-image file:', file.name, 'Type:', file.type);
    return file;
  };

  const uploadFiles = async (files: FileList, bucket: string) => {
    const uploadedUrls: string[] = [];
    
    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      console.log('Processing file', i + 1, 'of', files.length);
      
      const processedFile = await processFile(file);
      const fileExt = file.name.split('.').pop();
      const filePath = `${crypto.randomUUID()}.${fileExt}`;
      
      console.log('Uploading file:', filePath);
      const { error: uploadError } = await supabase.storage
        .from(bucket)
        .upload(filePath, processedFile);

      if (uploadError) {
        console.error('Upload error:', uploadError);
        throw uploadError;
      }

      const { data } = supabase.storage
        .from(bucket)
        .getPublicUrl(filePath);

      uploadedUrls.push(data.publicUrl);
      console.log('Upload complete:', data.publicUrl);
    }

    return uploadedUrls;
  };

  return { uploadFiles };
};